import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    overflow: 'hidden',
  },
  contentWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  imageWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1rem',
    overflow: 'hidden',
  },
  image: {
    width: { xs: '100%', md: '50%', lg: '584px' },
    height: '100%',
    borderRadius: '8px',
    img: {
      width: '100%',
      borderRadius: '8px',
    },
  },

  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
